import script from "./ViewWagon.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewWagon.vue?vue&type=script&setup=true&lang=ts"

import "./ViewWagon.vue?vue&type=style&index=0&id=2d78fd10&lang=scss"

const __exports__ = script;

export default __exports__